// @flow
import React from "react";
import { useSelector } from "react-redux";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoTaxaDeAdministracao,
  SelecaoJanelaMovel,
  SelecaoPeriodicidade,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

export const processarPeriodoComTaxaDeAdministracao = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        taxaDeAdministracao: edicaoMedida.taxaDeAdministracao,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        taxaDeAdministracao: edicaoMedida.taxaDeAdministracao,
        dataBase: dataBase,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PeriodoDiarioComTaxaDeAdministracao = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <div className="ConfiguracaoMedida">
        <SelecaoTaxaDeAdministracao />
        <SelecaoJanelaMovel />
      </div>
    );
  } else {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            <SelecaoPeriodicidade />
          </div>

          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>
        <SelecaoTaxaDeAdministracao incluirTaxaEfetiva={true} />
        <SelecaoCasasDecimais />
      </>
    );
  }
};

export default PeriodoDiarioComTaxaDeAdministracao;
